module.exports = __webpack_public_path__ + "img/send-offer-button-desktop-ru.ea709328.jpg";